var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.credential &&
    _vm.credential.apiEncryptedUser &&
    _vm.retailPerc === 1
    ? _c(
        "div",
        [
          _c("WelcomeModal"),
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row footer" }, [
              _c("div", { staticClass: "col-md-3" }, [
                _c("img", {
                  staticClass: "px- py-3",
                  attrs: { src: _vm.getLogoUrl() }
                })
              ]),
              _c("div", { staticClass: "col-md-6" }, [
                _vm._m(0),
                _c("div", { staticClass: "row contacts-row" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "col-md-4 d-block d-md-none" }, [
                    _c("a", { attrs: { href: "https://wa.me/3470419885" } }, [
                      _vm._v(_vm._s(_vm.$t("contact_us_whatsApp")))
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-md-4 d-none d-md-block whatsapp-col" },
                    [
                      _c("a", { attrs: { href: "https://wa.me/3470419885" } }, [
                        _vm._v(_vm._s(_vm.$t("contact_us_whatsApp")))
                      ])
                    ]
                  ),
                  _vm._m(2)
                ])
              ]),
              _c("div", { staticClass: "col-md-3" }, [
                _c("h5", { staticClass: "f-title text-uppercase" }, [
                  _vm._v(_vm._s(_vm.$t("follow_us")))
                ]),
                _c("div", [
                  _c(
                    "a",
                    {
                      staticClass: "social-icon",
                      attrs: {
                        target: "_blank",
                        href:
                          "https://www.instagram.com/gioielleriaitaliana/?hl=it"
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fab", "instagram"] }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "social-icon",
                      attrs: {
                        target: "_blank",
                        href:
                          "https://www.facebook.com/Gioielleria-Italiana-102304924791127"
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fab", "facebook"] }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "social-icon",
                      attrs: {
                        target: "_blank",
                        href:
                          "https://www.linkedin.com/company/gioielleria-italiana/"
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fab", "linkedin"] }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "col-md-12" }, [
                _vm._v(
                  " Copyright © 2022 Gioielleria Italiana S.r.l. - P. IVA 01797090097 - All rights reserved. "
                )
              ])
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row policies-row" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://www.gioielleriaitaliana.com/privacy-policy-2/"
            }
          },
          [_vm._v("PRIVACY POLICY")]
        )
      ]),
      _c("div", { staticClass: "col-md-4" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://www.gioielleriaitaliana.com/cookie-policy/"
            }
          },
          [_vm._v("COOKIE POLICY")]
        )
      ]),
      _c("div", { staticClass: "col-md-4" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("a", { attrs: { href: "tel:+393470419885" } }, [
        _vm._v("+393470419885")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("a", { attrs: { href: "mailto:info@gioielleriaitaliana.com" } }, [
        _vm._v("info@gioielleriaitaliana.com")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }